import { fetchBackend } from '@/utils/fetch'
import { UserModel } from '@/models/User.model'
import { AreaInfo } from '@/models/Area.model'

/**
 * 获取用户信息 + 用户权限
 */
export const getUserInfo = () =>
  fetchBackend.get('/pe/gatekeeper/user/info', {
    wrapper: UserModel
  })


// https://apidoc.nioint.com/project/8100/interface/api/778681
export const getAreaInfo = () => {
  return fetchBackend.get('/pe/gatekeeper/v1/user/difference', {
    wrapper: AreaInfo
  })
}
